<template>
    <DxButtonGroup
        :items="items"
        key-expr="value"
        styling-mode="outlined"
        :selected-item-keys="[locale]"
        selection-mode="single"
        :hint="t('language.label')"
        class="lang-switcher"
        @selection-changed="onChange"
    />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import DxButtonGroup from 'devextreme-vue/button-group'
import { setLocale } from '@/i18n'

const { t, locale } = useI18n()

const items = computed(() => [
    { text: 'DE', value: 'de' },
    { text: 'EN', value: 'en' },
])

function onChange(e) {
    const next = e.addedItems?.[0]?.value
    if (next && next !== locale.value) {
        setLocale(next)
    }
}
</script>

<style scoped>
.lang-switcher {
    --dx-component-height: 36px;
}

.lang-switcher :deep(.dx-button) {
    min-width: 44px;
    font-weight: 600;
    letter-spacing: 0.04em;
}
</style>
